const CSRF_SYNC_TIMEOUT_MS = 4000;

const applyCsrfToken = (token) => {
    if (!token) {
        return '';
    }

    let meta = document.head.querySelector('meta[name="csrf-token"]');

    if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'csrf-token';
        meta.id = 'csrf-token';
        document.head.appendChild(meta);
    }

    meta.setAttribute('content', token);

    document.querySelectorAll('input[name="_token"]').forEach((input) => {
        input.value = token;
    });

    window.livewireScriptConfig = window.livewireScriptConfig || {};
    window.livewireScriptConfig.csrf = token;

    return token;
};

const ensureCsrfToken = async () => {
    if (window.__vsebankiCsrfTokenPromise) {
        return window.__vsebankiCsrfTokenPromise;
    }

    window.__vsebankiCsrfTokenPromise = (async () => {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), CSRF_SYNC_TIMEOUT_MS);

        try {
            const response = await fetch('/csrf', {
                credentials: 'same-origin',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                signal: controller.signal,
            });

            if (!response.ok) {
                throw new Error(`CSRF token request failed with status ${response.status}`);
            }

            const data = await response.json();

            return applyCsrfToken(data?.token || '');
        } catch (error) {
            if (error?.name === 'AbortError') {
                console.error('CSRF token request timed out before Livewire start.');
            } else {
                console.error('Failed to sync CSRF token before Livewire start:', error);
            }

            return '';
        } finally {
            window.clearTimeout(timeoutId);
        }
    })();

    const token = await window.__vsebankiCsrfTokenPromise;

    if (!token) {
        window.__vsebankiCsrfTokenPromise = null;
    }

    return token;
};

const waitForDomReady = () => {
    if (document.readyState !== 'loading') {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        document.addEventListener('DOMContentLoaded', resolve, { once: true });
    });
};

const startLivewire = () => {
    if (window.__vsebankiLivewireStarted || window.__vsebankiLivewireStarting) {
        return;
    }

    if (!window.Livewire || typeof window.Livewire.start !== 'function') {
        console.error('Livewire is not available for manual start.');
        return;
    }

    window.__vsebankiLivewireStarting = true;

    try {
        window.Livewire.start();
        window.__vsebankiLivewireStarted = true;
    } catch (error) {
        console.error('Failed to start Livewire manually:', error);
    } finally {
        window.__vsebankiLivewireStarting = false;
    }
};

const scheduleLivewireStart = () => {
    if (window.__vsebankiLivewireStartScheduled) {
        return;
    }

    window.__vsebankiLivewireStartScheduled = true;

    Promise.all([waitForDomReady(), ensureCsrfToken()])
        .catch((error) => {
            console.error('Failed to prepare Livewire manual start:', error);
        })
        .finally(startLivewire);
};

window.__vsebankiApplyCsrfToken = window.__vsebankiApplyCsrfToken || applyCsrfToken;
window.__vsebankiEnsureCsrfToken = window.__vsebankiEnsureCsrfToken || ensureCsrfToken;

scheduleLivewireStart();
